<template>
  <input ref="datepicker" type='text' class="form-control form-control-sm" position="auto"/>
</template>
<script>
// import * as $ from 'jquery';
// import 'air-datepicker';
import 'air-datepicker/dist/js/datepicker.min';
import 'air-datepicker/dist/css/datepicker.min.css';


function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const fitsLeft = (rect.left >= 0 && rect.left <= $(window)
    .width());
  const fitsTop = (rect.top >= 0 && rect.top <= $(window)
    .height());
  const fitsRight = (rect.right >= 0 && rect.right <= $(window)
    .width());
  const fitsBottom = (rect.bottom >= 0 && rect.bottom <= $(window)
    .height());
  return {
    top: fitsTop,
    left: fitsLeft,
    right: fitsRight,
    bottom: fitsBottom,
    all: (fitsLeft && fitsTop && fitsRight && fitsBottom),
  };
}


export default {
  props: ['date'],
  data() {
    return {
      datepicker: null,
      viewDate: null,
      dateFormat: 'DD-MM-YYYY HH:mm',
      currentDate: null,
      lockOnSelectEvent: true,
    };
  },
  computed: {
    // viewDate() {
    //   // if (this.datepicker && this.datepicker.date) {
    //   return moment(new Date())
    //     .format();
    //   // }
    // },
  },
  watch: {
    date(newVal) {
      console.log('date watch', newVal);
      if (newVal) {
        this.lockOnSelectEvent = true;
        if (newVal) {
          this.datepicker.selectDate(new Date(newVal));
        }
        this.$nextTick(() => {
          this.lockOnSelectEvent = false;
        });
      }
    },

    currentDate(newVal, oldVal) {
      console.log('currentDate watch', newVal, this.lockOnSelectEvent);
      if (!this.lockOnSelectEvent && newVal) {
        this.$emit('onSelect', newVal);
      }
    },
  },
  mounted() {
    const that = this;
    const datepicker = $(this.$refs.datepicker);
    const config = {
      altFieldDateFormat: 'dd-mm-yyyy',
      // timepicker: true,
      dateFormat: 'dd-mm-yyyy',
      autoClose: true,
      position: 'bottom center', // Default position
      // weekends: [5, 6],
      onShow(inst, animationComplete) {
        // Just before showing the datepicker
        if (!animationComplete) {
          let iFits = false;
          // Loop through a few possible position and see which one fits
          $.each(['bottom center', 'right bottom', 'left bottom', 'top center', 'right center', 'right top', 'top center'], (i, pos) => {
            if (!iFits) {
              inst.update('position', pos);
              const fits = isElementInViewport(inst.$datepicker[0]);
              if (fits.all) {
                iFits = true;
              }
            }
          });
        }
      },
      onSelect(formattedDate, date, inst) {
        that.currentDate = date;
      },
      // onHide(inst, animationCompleted) {
      //   if (animationCompleted) {
      //
      //   console.log(inst)
      //   }
      //   // console.log('onSelect air date', date.getTime())
      //   // that.$emit('onSelect', date.getTime() / 1000);
      // },
    };
    // setInterval(() => {
    //   console.log(this.date);
    // }, 1000);
    datepicker.datepicker(config);

    this.datepicker = datepicker.data('datepicker');
  },
};
</script>
